const ArtifactBrowserEvents = {
    FILE_SELECTED: 'file-selected',
    FILE_CREATED: 'file-created',
    FILE_DELETED: 'file-deleted',
    FOLDER_SELECTED: 'folder-selected',
    FOLDER_CREATED: 'folder-created',
    FOLDER_DELETED: 'folder-deleted',
}

export default ArtifactBrowserEvents;